import { render, staticRenderFns } from "./FilePondUpload.vue?vue&type=template&id=5efd4142&"
import script from "./FilePondUpload.vue?vue&type=script&lang=js&"
export * from "./FilePondUpload.vue?vue&type=script&lang=js&"
import style0 from "./FilePondUpload.vue?vue&type=style&index=0&id=5efd4142&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports